import { storeToRefs } from 'pinia';
import { useWhiteLabelStore } from '@/stores/white-label/WhiteLabelStore';

export const getWhiteLabelState = () => {
  const whiteLabelStore = useWhiteLabelStore();
  return storeToRefs(whiteLabelStore);
};

export const getActivationType = () => {
  const whiteLabelStore = useWhiteLabelStore();
  const { isSingleSeller, isMultiSeller, activationType } = storeToRefs(whiteLabelStore);

  return {
    isSingleSeller,
    isMultiSeller,
    activationType,
  };
};
